import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAccountStorage } from "../hooks/useAccountStorage";
import { landingForType, Space, spaceForType } from "../utils/roles";

// RoleRoute : protège un groupe de routes propre à un espace. Vérifie le token (sinon -> login),
// puis que l'espace de l'utilisateur correspond bien à celui du groupe ; sinon on le renvoie vers
// l'accueil de SON espace (ex. un éleveur qui force /admin/... repart sur /breeder).
// Rappel : garde-fou UX uniquement — le backend reste responsable du vrai contrôle d'accès.
export const RoleRoute = ({ space }: { space: Space }) => {
  const navigate = useNavigate();
  const { getAccountStorage } = useAccountStorage();
  const type = getAccountStorage()?.type;

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    if (type && spaceForType(type) !== space) {
      navigate(landingForType(type), { replace: true });
    }
  }, [navigate, type, space]);

  return <Outlet />;
};
